import React from 'react';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import './DatePick.scss';

interface IProps {
  onChange: any,
  value: any,
  label?: string,
  minDate?: Date,
  maxDate?: Date,
  disabled?: boolean,
  showTimeSelect?: boolean,
  timeOnly?: boolean,
  className?: string,
  innerClassName?: string,
  required?: boolean,
  rightText?: string,
  isClearable?: boolean,
  placeholder?: string,
  open?: boolean
}

const CustomInput = React.forwardRef<HTMLInputElement, any>(
  ({ value, onClick, placeholder, disabled, rightText }, ref) => (
    <div className="customInputWrapper">
      <input
        type="text"
        onClick={onClick}
        ref={ref}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        readOnly
      />
      {rightText && <span className="rightText">{rightText}</span>}
    </div>
  )
);

const DatePick: React.FC<IProps> = ({
      onChange,
      value,
      label = "Date",
      minDate = undefined,
      maxDate = undefined,
      disabled = false,
      showTimeSelect = false,
      timeOnly = false,
      className = undefined,
      required = false,
      rightText = "",
      isClearable = false,
      placeholder = undefined,
      open = false
    }) => {
  return (
    <div className={className ? "DatePick " + className : "DatePick"}>
      <div className="label"><span>{label}{!placeholder && !timeOnly && " (MM/DD/YYYY)"}</span></div>
      <div className="dateInner">
        <DatePicker
          required={required}
          minDate={minDate ? new Date(minDate) : undefined}
          maxDate={maxDate ? new Date(maxDate) : undefined}
          dateFormat={timeOnly ? "h:mm a" : showTimeSelect ? "MM/dd/yyyy h:mm a" : "MM/dd/yyyy"}
          showTimeSelect={showTimeSelect || timeOnly}
          showTimeSelectOnly={timeOnly}
          timeIntervals={15}
          disabled={disabled}
          selected={value}
          onChange={onChange}
          isClearable={isClearable}
          placeholderText={placeholder}
          customInput={
            rightText && <CustomInput rightText={rightText} />
          }
          {...(open ? { open: true } : {})}
        />
      </div>
    </div>
  );
}

export default DatePick;